import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BreadcrumbItem } from './models/breadcrumb-item.model';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe, LocalizePipe],
})
export class BreadcrumbComponent {
    @Input({ required: true }) breadcrumbs!: BreadcrumbItem[];
}
